import React from "react";
import Faq from "../components/sections/Faq";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { faqMetaData } from "../seo/metaDeta";

const MainFaq = [
  {
    question: "Which cloud providers do you support?",
    answer:
      "We currently support AWS and Microsoft Azure, but we are in the process of offering our stack for other cloud providers as well.",
  },
  {
    question: "Where does my data get stored?",
    answer:
      "We deploy the stack in your cloud, so all the data stays in your cloud. We have NO access to your data, only the system metrics come to us.",
  },
  {
    question: "Do we incur any cost when we deploy Datazip on our cloud?",
    answer:
      "Yes, since the stack is deployed in your cloud, the underlying infrastructure would cost about $230 USD a month",
  },
  {
    question: "Do you have any documentation, or knowledge base?",
    answer: (
      <div>
        Yes we have in-depth documentation which can be found{" "}
        <a
          href=" https://docs.datazip.io/s/home"
          target={"_blank"}
          rel="noreferrer noopener"
        >
          here
        </a>
        . For further support since we use open source tools, you can also check
        out the documentation for them if you have any specific questions:
        <br />
        (Warehouse):{" "}
        <a
          href="https://clickhouse.com/docs/en/sql-reference/BI"
          target={"_blank"}
          rel="noreferrer noopener"
        >
          Clickhouse documentation
        </a>
        <br />
        (charts and dashboarding):
        <a
          href=" https://docs.preset.io/"
          target={"_blank"}
          rel="noreferrer noopener"
        >
          {" "}
          superset documentation
        </a>
      </div>
    ),
  },
  {
    question: "Can I connect Datazip back to my backend or any other tool?",
    answer:
      "Yes we give open APIs to the integrated warehouse (Clickhouse), you can connect to data warehouse using HTTP endpoints, Python, Java, NodeJS, Golang",
  },
  {
    question: "How many users/dashboards can I have per plan?",
    answer: (
      <div>
        You can create an unlimited number of users/dashboards using
        comprehensive RBAC and charts & dashboards features in the product. If
        the latency or performance starts getting affected because of high
        concurrent usage, get in contact with us at{" "}
        <a href="mailto:hello@datazip.io">hello@datazip.io</a> for scaling the
        underlying infrastructure.
      </div>
    ),
  },
  {
    question:
      "I have more questions, what is the best way to reach out to you?",
    answer: (
      <div>
        Please write to <a href="mailto:hello@datazip.io">hello@datazip.io</a>{" "}
        and we will quickly get back to you.
      </div>
    ),
  },
];

const FaqPage = () => {
  return (
    <div className="container faq-page">
      <HelmetWrapper {...faqMetaData} />
      <Faq showHeading={true} data={MainFaq} />
    </div>
  );
};

export default FaqPage;
